import React from "react";
import { Button, Drawer, Spin, message } from "antd";
import CaseLeegalityAgreementService from "../../services/case-leegality-agreement-service";
import { sanitizeTemplateHtml } from "utilities/sanitize-html";



export  class LeegalityTemplateDrawer extends React.Component {
    state={
        loading: false
    }
    componentDidMount() {
    }

    componentDidUpdate(prevProps){
        if((this.props.templateData != prevProps.templateData) && this.props.isVisible){
            this.setData();
        }
    }

    setData(){
        const{templateData} =  this.props;
        this.setState({
            loading: true
        })
        setTimeout(() => {
            if(document.getElementById('inside-html')){
                let fields = templateData['json_data']['fields'];
                let template = templateData['template'];
        
                document.getElementById('inside-html').innerHTML = sanitizeTemplateHtml(template);
                    setTimeout(() => {
                        let failedFields = [];
                        fields.map(_ => {
                            if ((_.value || _.value == 0) && document.getElementById(_.id) && _.type != "file") {
                                // Get the old element
                                    const oldElement = document.getElementById(_.id);
    
                                    // Create a new label element
                                    const newLabel = document.createElement('label');
                                    newLabel.id = _.id;
                                    newLabel.textContent = _.value;
                                    newLabel.style.fontSize = "14px"
                                    oldElement.replaceWith(newLabel);
    
                                // document.getElementById(_.id).replaceWith(`<label id=${_.id}>${_.value}</label>`);
                                // document.getElementById(_.id).setAttribute('value', _.value)
                            } else if (_.value && document.getElementById(_.id) && _.type == 'file') {
                                document.getElementById(_.id).setAttribute('src', _.value)
                                document.getElementById(_.id).setAttribute('type', 'image')
                            } {
                                failedFields.push()
                            }
                        })
                        let allInputs = document.getElementById('inside-html').getElementsByTagName('input');
                        for (let index = 0; index < allInputs.length; ++index) {
                            allInputs[index].setAttribute('readOnly', true)
                            allInputs[index].setAttribute('disabled', true)
                        }
                        this.setState({
                            loading : false
                        })
                    },1000)
            }
        },1000)
            
    }

    triggerEsign = () => {
        const{templateData} =  this.props;
        this.setState({
            loading: true
        })
        let payload = {
            'html' : document.getElementById('inside-html').innerHTML,
            "case_id": this.props.caseId,
            "json_data": templateData['json_data'],
            "road_map_id": templateData['road_map_id'],
            "additional_files" : templateData['additional_files'],
            "invitation_data": templateData["invitation_data"],
            "company_id" : this.props.companyId
        };

        if(this.props.dbAgreement){
            let data = {
                ...this.props.templateData,
                html : document.getElementById('inside-html').innerHTML,
                "company_id" : this.props.companyId,
                "esign_provider" : this.props.templateData.document_id === 11 ? "legality" : undefined
            }

            CaseLeegalityAgreementService.triggerDBEsign(data).then((response) => {
                message.success("E-sign Triggered Successfully")
                this.setState({
                    loading: false
                })
                this.props.handleEsignDrawer(true)
            }).catch((error) => {
                message.error("Failed to trigger E-sign")
                this.setState({
                    loading: false
                })
                console.log(error);
            })
        }else{
            CaseLeegalityAgreementService.triggerEsign(payload)
            .then((response) => {
                message.success("E-sign Triggered Successfully")
                this.setState({
                    loading: false
                })
                this.props.handleEsignDrawer(true)
                }).catch((error) => {
                    message.error("Failed to trigger E-sign")
                    this.setState({
                        loading: false
                    })
                    console.log(error);
            })
        }
    }
 
    render() {
        return (
            <Drawer
                    visible={this.props.isVisible}
                    onClose={() => this.props.handleEsignDrawer()}
                    width="100VW"
                    
                >
                    <Spin spinning={this.state.loading}>
                        <div className="d-flex justify-content-space-between align-items-center mt-5">
                            <h1>E Sign</h1>
                            <div>
                                {this.props.showTriggerButton && <Button type="primary" onClick={() => this.triggerEsign()}>Trigger</Button>}
                                <Button type="link" onClick={() => this.props.handleEsignDrawer()}>Cancel</Button>
                            </div>
                        </div>
                        <div id="inside-html" style={{
                            height: "100vh",
                            overflowX : 'scroll',
                            userSelect: 'none'
                        }}>
                           
                        </div>
                    </Spin>
                </Drawer>
            
        )
    }
}